
import DesktopFooter from "./desktop/DesktopFooter";
import MobileFooter from "./mobile/MobileFooter";

export default function Footer({ isDesktop, activeButton, isHomePage = false }) {
	return (
		<>
			{isDesktop ? (
				<DesktopFooter isHomePage={isHomePage} />
			) : (
				<MobileFooter activeButton={activeButton} isHomePage={isHomePage} />
			)}
		</>
	)
}
